<template>
  <div class="el_container">
    <div class="el_title">例題</div>
    <div class="el_question_text">
      まずは例題に取り組んでもらいます。以下の3コマのストーリーを読み、この状況であなたが取るかもしれない行動それぞれについて、「する」または「しない」のどちらかを選んでください。
    </div>
    <div class="ly_img_content">
      <img class="el_img_size" src="../../assets/psychologytest1/0.png" />
    </div>
    <div class="ly_ans">回答</div>
    <div
      class="ly_radio_buttons"
      v-for="(question, question_index) in placeholder.questions"
      v-bind:key="question.id"
    >
      <div :class="`ly_radio_${question_index % 2}`">
        <div class="ly_radio_text"><span>[{{ question.id }}]</span><span>{{ question.label }}</span></div>
        <material-radio-button class="ly_radio_button"></material-radio-button
        ><br />
      </div>
    </div>
    <div class="ly_next_button">
      <MaterialButton
        text="次へ"
        link="start"
        font-size="28px"
        padding="10px 52px 10px 52px"
      ></MaterialButton>
    </div>
  </div>
</template>

<script>
import MaterialButton from '../atoms/MaterialButton'
import MaterialRadioButton from '../atoms/MaterialRadioButton'
// import questions from '../../assets/psychologytest1.json'

export default {
  name: 'Problem',
  components: { MaterialRadioButton, MaterialButton },
  data: () => ({
    placeholder: {
      id: 0,
      description:
        'まずは例題に取り組んでもらいます。以下の３コマのストーリーを読み、この状況であなたがとるかもしれない行動それぞれについて、「する」または「しない」のどちらかを選んでください。',
      story:
        '学校の授業が終わり家に帰ってきた \n今日は家族もd出かけてしまって、夜遅くまで暇だなぁ。\n③天気も悪いようだし、家で一人で何　をしようか。',
      questions: [
        {
          id: 1,
          label: '学校の授業を復習する',
          answer: 2,
        },
        {
          id: 2,
          label: '好きなテレビ番組を見る',
          answer: 2,
        },
        {
          id: 3,
          label: '好きな漫画を読む',
          answer: 2,
        },
        {
          id: 4,
          label: '好きな音楽を聴く',
          answer: 2,
        },
      ],
    },
    // questions: questions,
  }),
}
</script>

<style scoped>
.el_container {
  padding: 0px 10% 0px 10%;
}
.el_title {
  position: relative;
  width: 117px;
  height: 53px;
  text-align: left;
  top: 48px;
  font-size: 36px;
  color: #6b6b6b;
}

.el_question_text {
  position: relative;
  width: 100%;
  height: 84px;
  top: 74px;
  text-align: left;

  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;

  color: #6b6b6b;
}

.ly_img_content {
  display: flex;
  position: relative;
  top: 68px;
}

.el_img_size {
  width: 100%;
}

.ly_ans {
  position: relative;
  text-align: left;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;

  color: #6b6b6b;

  width: 58px;
  height: 41px;
  top: 98px;
}

.ly_radio_buttons {
  position: relative;
  top: 90px;
  width: 800px;
}

.ly_radio {
  display: flex;
  margin-top: 28px;
  padding: 14px;
}
.ly_radio_0 {
  display: flex;
  padding: 14px;
}
.ly_radio_1 {
  display: flex;
  padding: 14px;
  background-color: #fafafa;
}

.ly_radio_text {
  align-self: flex-start;
  text-align: left;
}

.ly_radio_text span {
  margin-left: 1em;
  /* text-indent: 1em; */
  /* padding-left: 1.3em; */
}

.ly_radio_button {
  margin-left: auto;
}

.ly_button {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  top: 177px;
  padding-bottom: 44px;
}

.ly_next_button {
  position: relative;
  text-align: end;
  width: 100%;
  top: 177px;
  padding-bottom: 44px;
}
</style>
